var Model = require('../Model');

var Action = Object.create(Model);

Action.name = 'Calibration';
Action['@class'] = 'Calibration';
Action.url = 'calibration';

Action.fields = {
  asset: {
    default: null,
    hidden: true,
    validators: {
      presence: true, 
    }
  },
  instrument: {
    default: null,
    hidden: true,
    validators: {
      presence: true, 
    }
  },
  certificateNumber: {
    default: null,
    hidden: true,
  },
  calibrationDate: {
    default: null,
    hidden: true,
  },
  validTill: {
    default: null,
    hidden: true,
  },
  frequency: {
    default: null,
    hidden: true,
  },
  performedBy: {
    default: null,
    validators: {
      presence: true, 
    }
  },
  resultSummary: {
    default: 0,
    validators: {
      presence: true, 
    }
  },
  offset: {
    default: 0,
    validators: {
      presence: true, 
    }
  },
  foundAs: {
    default: 0,
    hidden: true,
    validators: {
      presence: true, 
    }
  },
  sourceReference: {
    default: 0,
    hidden: true,
    validators : {
      presence: true
    }
  },
  leftAs: {
    default: 0,
    hidden: true,
    validators : {
      presence: true
    }
  },
  timestamp: {
    default: null
  }
};

module.exports = Action;
